<template>
    <div class="relative inline-block align-bottom cursor-pointer">
        <!-- prettier-ignore -->
        <svg class="icon--cart w-7 h-7 transition-all duration-500" :class="variant === 'on-blue' ? 'text-white' : 'text-blue-500'" xmlns="http://www.w3.org/2000/svg" width="29" height="27" viewBox="0 0 29 27" role="img" aria-label="View cart" focusable="false">
            <g fill="currentColor">
                <path d="M28.215 5.61c-.544-.69-1.39-1.11-2.266-1.11H7.552l-.574-2.22C6.646.99 5.498.09 4.168.09h-3.08C.573.09.15.51.15 1.02s.423.93.936.93H4.17c.453 0 .846.3.966.75l3.686 14.58c.332 1.29 1.48 2.19 2.81 2.19h12.052c1.33 0 2.508-.9 2.81-2.19l2.265-9.24c.212-.84.03-1.74-.543-2.43zm-1.3 2.01l-2.265 9.24c-.12.45-.514.75-.967.75H11.63c-.453 0-.846-.3-.966-.75L8.035 6.39H25.95c.302 0 .604.15.785.39.182.24.272.54.182.84zM12.265 20.67c-1.722 0-3.142 1.41-3.142 3.12 0 1.71 1.42 3.12 3.142 3.12 1.721 0 3.141-1.41 3.141-3.12 0-1.71-1.42-3.12-3.141-3.12zm0 4.35c-.695 0-1.239-.54-1.239-1.23s.544-1.23 1.239-1.23c.694 0 1.238.54 1.238 1.23 0 .66-.574 1.23-1.238 1.23zM22.656 20.67c-1.722 0-3.141 1.41-3.141 3.12 0 1.71 1.42 3.12 3.141 3.12 1.722 0 3.142-1.41 3.142-3.12-.03-1.71-1.42-3.12-3.142-3.12zm0 4.35c-.695 0-1.238-.54-1.238-1.23s.543-1.23 1.238-1.23 1.239.54 1.239 1.23c0 .66-.574 1.23-1.239 1.23z" />
            </g>
        </svg>
        <span
            v-if="count"
            class="absolute flex justify-center top-0 right-0 w-4 h-4 -mt-2 -mr-2 items-center tiny leading-none rounded-full transition-all duraction-500"
            :class="
                variant === 'on-yellow' ? 'bg-white text-blue-500' : 'bg-yellow-500 text-blue-500'
            "
            >{{ count }}</span
        >
    </div>
</template>
<script>
export default {
    props: {
        count: {
            type: Number,
            default: 0
        },
        variant: {
            type: String,
            default: 'on-blue'
        }
    }
};
</script>
